import formatPhone, { formatPhoneCopyText, formatPhoneTelHref } from "@/utils/format-phone"
import { ButtonBadge } from "@ui/button-badge"

interface ContactPhoneBadgeProps {
  value?: string | null
  extension?: string | null
  onClick?: () => void
}

function formatPhoneSafe(phone: string) {
  try {
    return formatPhone(phone)
  } catch {
    return phone
  }
}

export function ContactInfoBadge({ value, extension, onClick }: ContactPhoneBadgeProps) {
  if (!value) return "-"

  const displayValue = formatPhoneSafe(value)
  return (
    <ButtonBadge
      text={displayValue}
      copyText={formatPhoneCopyText(value, extension)}
      onClick={onClick}
      href={onClick ? undefined : formatPhoneTelHref(value, extension)}
    >
      <span className="inline-flex min-w-0 items-center">
        <span className="truncate">{displayValue}</span>
        {extension && (
          <>
            <span className="text-blue-foreground/60 mx-1">·</span>
            <span className="text-blue-foreground/70">ext {extension}</span>
          </>
        )}
      </span>
    </ButtonBadge>
  )
}
